import React from 'react';

const Privacy = props => {

    return (
        <div className="container g-pt-140 g-pb-50">
            <div className="u-heading-v3-1 g-pt-20">
                <h2 className="h3 u-heading-v3__title g-brd-primary g-brd-bottom-2--md g-font-size-22 g-font-weight-600 g-line-height-0_7">개인정보처리방침</h2>
                <ul className="u-list-inline pull-right g-pt-2 g-font-size-13">
                    <li className="list-inline-item g-mr-5"><a className="u-link-v5 g-color-main" href="/">Home</a> <i className="g-color-gray-light-v2 g-ml-5">/</i></li>
                    <li className="list-inline-item g-color-primary"><span>개인정보처리방침</span></li>
                </ul>
            </div>

            <p className="g-pt-30">
                (사)동물권행동 카라(이하 '카라')는 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.
		        카라는  개인정보처리방침을 개정하는 경우 웹사이트 공지사항을 통하여 공지할 것입니다.<br /> *본 방침은 2021년 1월 1일부터 시행합니다.
	         </p>

            <div className="row justify-content-center">
                <div className="col-lg-9">
                    <h2 className="h5 g-color-black g-mt-30"><span className="g-font-weight-700">1.</span> 개인정보의 처리 목적</h2>
                    <p>카라는 개인정보를 다음의 목적을 위해 처리합니다. <br />처리한 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다.</p>
                    <p>
                        (1) 회원가입 및 유지<br />
                        (2) 비정기 또는 일시 후원<br />
                        (3) 카라 활동내용 공유<br />
                        (4) 정보 문의와 민원 상담<br />
                        (5) 행사와 활동 참여: 행사 정보 제공 및 참여기회 제공 등<br />
                    </p>


                    <h2 className="h5 g-color-black g-mt-30"><span className="g-font-weight-700">2.</span> 처리하는 개인정보 항목</h2>
                    <p>
                        (1) 회원 가입과 유지<br />
                        카라는 회원 기본정보(이름, 성별, 나이, 직업), 후원정보(주민등록번호, 후원방법, 후원 약정액, 후원 계좌 또는 신용카드 번호, 신용카드 유효기간), 연락 및 의사소통을 위한 정보(우편물 수령 주소,
                        휴대전화번호, 이메일, 페이스북 계정, 트위터 계정)를 수집하고 있습니다. 단, 만 20세 미만 미성년자는 법정대리인(보호자)의 정보를 요구할 수 있습니다.
			        </p>
                    <p>
                        (2) 비정기 또는 일시 후원<br />
                        카라에 비정기 또는 일시로 후원하는 후원자는 기본정보(이름 또는 단체명), 후원정보(주민등록번호 또는 사업자등록번호, 후원계좌/신용카드번호/휴대전화번호, 신용카드 유효기간), 연락 및 의사소통을 위한 정보(우편물 수령주소, 전화번호, 이메일)를 수집하고 있습니다.
			        </p>
                    <p>
                        (3) 카라 활동내용 공유<br />
                        카라는 회원이 아니더라도 활동 소식을 정기적으로 받아보기 원하는 개인 또는 단체의 정보를 수집하고 있습니다. 이는 이용자의 동의에 따라 자발적으로 제공한 정보에 한하며, 이름과 이메일 이외의 어떤 정보도 수집하지 않습니다.
			        </p>
                    <p>
                        (4) 정보 문의와 민원 상담<br />
                        카라는 회원과 시민들이 상담을 요청하거나 제보를 하는 경우 의사소통을 원활히 하기 위해 이름, 연락처(휴대전화번호 또는 이메일) 등의 정보를 수집하여 처리하고 있습니다. 
			        </p>
                    <p>
                        (5) 행사와 활동 참여<br />
                        카라가 주최 혹은 주관하는 행사와 설문조사와 같은 활동에 회원과 시민들이 참여를 원할 경우 내용 공유와 진행을 위해 개인정보 수집에 대한 동의를 얻은 후 이름, 휴대전화번호, 이메일 등의 정보를 요구할 수 있습니다. 
			        </p>

                    <h2 className="h5 g-color-black g-mt-30"><span className="g-font-weight-700">3.</span> 개인정보의 처리 및 보유 기간</h2>
                    <p>① 카라는 관계법령의 규정에 따라 개인정보를 보존하여야 하는 의무가 있는 경우가 아닌 한, 정보주체의 개인정보는 원칙적으로 해당 개인정보의 처리목적이 달성될 때까지 보유 및 이용되며, 그 목적이 달성되면 지체 없이 파기됩니다.</p>
                    <p>② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
                    <p>(1) 회원 정보</p>
                    <ul>
                        <li>보유기간: 회원 탈퇴시까지</li>
                        <li>보유사유: 회원약관 동의</li>
                    </ul>
                    <p>(2) 자원활동 신청시</p>
                    <ul>
                        <li>보유기간: 삭제 요청시까지</li>
                        <li>보유사유: 신청자 동의</li>
                    </ul>
                    <p>(3) 물품 후원자의 기부금영수증 발급 관련 정보</p>
                    <ul>
                        <li>보유기간: 5년</li>
                        <li>보유사유: 법인세법 제112조 2에 따라 기부자별 발급명세 5년간 보존</li>
                    </ul>


                    <h2 className="h5 g-color-black g-mt-30"><span className="g-font-weight-700">4.</span> 개인정보의 제3자 제공</h2>
                    <p>카라는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.	</p>


                    <h2 className="h5 g-color-black g-mt-30"><span className="g-font-weight-700">5.</span> 개인정보처리 위탁</h2>
                    <p>① 카라는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
                    <table className="table table-bordered">
                        <tbody>
                            <tr><td>㈜휴먼소프트웨어</td><td>회원DB관리 및 후원금 결제정보 관리</td></tr>
                            <tr><td>금융결제원</td><td>정기 후원금 CMS 자동이체 납입 및 내역 관리</td></tr>
                            <tr><td>㈜나이스정보통신</td><td>신용카드. 실시간 계좌이체 후원금 결제</td></tr>
                            <tr><td>로젠택배</td><td>상품 배송</td></tr>
                        </tbody>
                    </table>
                    <p>② 카라는 위탁계약 체결시 개인정보 보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>
                    <p>③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</p>


                    <h2 className="h5 g-color-black g-mt-30"><span className="g-font-weight-700">6.</span> 정보주체의 권리, 의무 및 그 행사방법</h2>
                    <p>이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.</p>
                    <p>① 정보주체는 카라에 대해 언제든지 개인정보 열람요구, 오류 등이 있을 경우 정정 요구, 삭제요구, 처리정지 요구의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
                    <p>② 제1항에 따른 권리 행사는 카라에 대해 개인정보 보호법 시행규칙 별지 제8호 서식에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 카라는 이에 대해 지체 없이 조치하겠습니다.</p>
                    <p>③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 카라는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</p>
                    <p>④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</p>


                    <h2 className="h5 g-color-black g-mt-30"><span className="g-font-weight-700">7.</span> 처리하는 개인정보의 항목</h2>
                    <p>카라는 다음의 개인정보 항목을 처리하고 있습니다.</p>
                    <p>1. 회원/후원자/이용자 식별 : 이름, 생년월일, 이메일, 휴대전화번호</p>
                    <p>2. 후원금 후원 요청 : 후원계좌, 신용카드 결제 정보, 휴대전화번호</p>
                    <p>3. 활동내용 공유 경로 확보 : 이메일, 휴대전화번호, 우편물 수령 주소, 페이스북 계정, 트위터 계정</p>
                    <p>4. 기부금 영수증 발급 : 이름, 주민등록번호, 후원내역	</p>


                    <h2 className="h5 g-color-black g-mt-30"><span className="g-font-weight-700">8.</span> 개인정보의 파기</h2>
                    <p>카라는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.</p>
                    <p> ○  파기절차</p>
                    <p className="left">이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.</p>
                    <p> ○  파기기한</p>
                    <p className="left">이용자의 개인정보는 보유기간이 만료되었거나 개인정보의 처리목적달성, 해당 업무의 폐지 등 그 개인정보가 불필요하게 되었을 때에는 지체없이 파기합니다.</p>
                    <p> ○  파기방법</p>
                    <ul>
                        <li>전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.</li>
                        <li>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>
                    </ul>


                    <h2 className="h5 g-color-black g-mt-30"><span className="g-font-weight-700">9.</span> 개인정보의 안전성 확보 조치</h2>
                    <p>카라는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적, 관리적, 물리적 조치를 하고 있습니다.</p>
                    <p> ○  개인정보 취급 직원의 최소화 및 교육</p>
                    <p className="left">개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.</p>
                    <p> ○  개인정보에 대한 접근 제한</p>
                    <p className="left">개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.</p>
                    <p> ○  내부관리계획의 수립 및 시행</p>
                    <p className="left">개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.</p>
                    <p> ○  해킹 등에 대비한 기술적 대책</p>
                    <p className="left">카라는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.</p>
                    <p> ○  개인정보의 암호화</p>
                    <p className="left">이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.</p>
                    <p> ○  접속기록의 보관 및 위변조 방지</p>
                    <p className="left">개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능 사용하고 있습니다.</p>
                    <p> ○  문서보안을 위한 잠금장치 사용</p>
                    <p className="left">개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.</p>
                    <p> ○  비인가자에 대한 출입 통제</p>
                    <p className="left">개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.</p>


                    <h2 className="h5 g-color-black g-mt-30"><span className="g-font-weight-700">10.</span> 개인정보 보호책임자 및 담당자</h2>
                    <p>카라는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
                    <p> ○  개인정보 보호책임자: 사무국장 소연주 (02-3482-0999, info@ekara.org)</p>
                    <p> ○  개인정보 보호 담당 부서: 카라사무국</p>
                    <p>정보주체께서는 카라의 서비스을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 카라는 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.</p>


                    <h2 className="h5 g-color-black g-mt-30"><span className="g-font-weight-700">11.</span> 권익침해 구제방법</h2>
                    <p>정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.</p>
                    <ul>
                        <li>개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)</li>
                        <li>개인정보분쟁조정위원회 (www.kopico.go.kr / 1833-6972)</li>
                        <li>대검찰청 사이버수사과 (www.spo.go.kr / 국번없이 1301)</li>
                        <li>경찰청 사이버안전국 (cyberbureau.police.go.kr / 국번없이 182)</li>
                    </ul>
                    <p>「개인정보보호법」제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대 하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.</p>
                    <p>※ 행정심판에 대해 자세한 사항은 법제처 (http://www.moleg.go.kr) 홈페이지를 참고하시기 바랍니다.</p>

                    <h2 className="h5 g-color-black g-mt-30"><span className="g-font-weight-700">12.</span> 영상정보처리기기 설치․운영</h2>
                    <p>① 카라는 아래와 같이 영상정보처리기기를 설치․운영하고 있습니다. </p>
                    <p>1. 영상정보처리기기 설치근거․목적 : 카라의 시설안전․화재예방</p>
                    <p>2. 설치 대수, 설치 위치, 촬영 범위 : [사옥 로비 등 주요시설물]에 49대 설치, 촬영범위는 주요시설물의 전 공간을 촬영 </p>
                    <p>3. 관리책임자, 담당부서 및 영상정보에 대한 접근권한자 : 사무국 (사무국장, 총무)</p>
                    <p>4. 영상정보 촬영시간, 보관기간, 보관장소, 처리방법</p>
                    <ul>
                        <li>촬영시간 : 24시간 촬영</li>
                        <li>보관기간 : 촬영시부터 30일</li>
                        <li>보관장소 및 처리방법 : 사무국 영상정보처리기기 통제실에 보관․처리</li>
                    </ul>
                    <p>5. 영상정보 확인 방법 및 장소 : 관리책임자에 요구 (사무국) </p>
                    <p>6. 정보주체의 영상정보 열람 등 요구에 대한 조치 : 개인영상정보 열람․존재확인 청구서로 신청하여야 하며, 정보주체 자신이 촬영된 경우 또는 명백히 정보주체의 생명․신체․재산 이익을 위해 필요한 경우에 한해 열람을 허용합니다.</p>
                    <p>7. 영상정보 보호를 위한 기술적․관리적․물리적 조치 : 내부관리계획 수립, 접근통제 및 접근권한 제한, 영상정보의 안전한 저장․전송기술 적용, 처리기록 보관 및 위․변조 방지조치, 보관시설 마련 및 잠금장치 설치</p>

                    <h2 className="h5 g-color-black g-mt-30"><span className="g-font-weight-700">13.</span> 개인정보 처리방침의 변경</h2>
                    <p>이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이 있는 경우에는 홈페이지의 '공지사항'을 통해 이전의 개인정보 처리방침을 고지할 것입니다.</p>
                    <p> - 공고일자: 2021년 1월 1일</p>
                </div>
            </div>
        </div>

    )
}

export default Privacy;


// WEBPACK FOOTER //
// ./src/pages/front/policy/privacy.js